<template>
  <div>
    <div class="map-link-box">
      <h1>请选择您已安装的地图App</h1>
      <!-- <a href="http://map.baidu.com/mobile/direction?origin=latlng:34.264642646862,108.95108518068|name:我家&destination=大雁塔&mode=driving&region=西安&output=html&src=webapp.baidu.openAPIdemo">百度地图</a>
        <a href="https://uri.amap.com/navigation?from=116.478346,39.997361,startpoint&to=116.3246,39.966577,endpoint&via=116.402796,39.936915,midwaypoint&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0">高德地图</a>
        <a href="https://apis.map.qq.com/uri/v1/routeplan?type=bus&from=我的家&fromcoord=39.980683,116.302&to=中关村&tocoord=39.9836,116.3164&policy=1&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77">腾讯地图</a> -->
      <a data-flag="bdapp"
         @click="openMapAPP($event)"
      >百度地图</a>
      <a data-flag="qqmap"
         @click="openMapAPP($event)"
      >腾讯地图</a>
      <a data-flag="androidamap"
         @click="openMapAPP($event)"
      >高德地图</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationNav",
  computed: {
    local() {
      return {};
    }
  },
  methods: {
    openMapAPP(action) {
      const local = this.$store.state.app.ApplicationData.local;
      if (this.$tu.isObjectBlank(local)) {
        console.error("位置信息没有传递进来");
        return;
      }
      if (!local.latitude || !local.longitude) {
        console.error("位置信息没有传递进来");
        return;
      }
      const self = this;
      let ifm = document.getElementsByTagName("iframe");
      const url = {
        bdapp: "bdapp://map/marker?location=" + self.local.latitude + "," + self.local.longitude + "&title=" + self.local.title + "&traffic=on&src=andr.xyj.haohaiyou",
        qqmap: "qqmap://map/geocoder?coord=" + self.local.latitude + "," + self.local.longitude + "&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77",
        androidamap: "androidamap://viewMap?sourceApplication=" + "&lat=" + self.local.latitude + "&lon=" + self.local.longitude + "&haohaiyou&poiname=" + self.local.title + "&116.1&dev=0"
      };
      const mapFlag = action.target.getAttribute("data-flag");
      if (ifm.length > 0) {
        document.body.removeChild(ifm[0]);
      }
      ifm = document.createElement("iframe");
      ifm.setAttribute("src", url[mapFlag]);
      ifm.setAttribute("name", "loadmap");
      ifm.setAttribute("style", "display:none;");
      document.body.appendChild(ifm);
    }
  }
};
</script>

<style lang="scss">
  .map-link-box {
    position: absolute;
    bottom: -20.5rem;
    z-index: 3001;
    width: 100%;
    background: white;
    display: flex;
    padding: 0.2rem 0;
    flex-wrap: nowrap;
    flex-direction: column;
    transition: all .3s ease;
    -webkit-transition: all .3s ease;
  }
  .map-link-box h1,
  .map-link-box a {
    width: 100%;
    color: #007fff;
    text-align: center;
    padding: .3rem 0;
    font-size: .36rem;
  }
  .map-link-box h1 {
    color: #999999;
    font-size: .3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/appComponents/locationNav.vue